import { VtmnTag } from '@vtmn/react';
import { useEffect, useState } from 'react';

type ModelTagStatusProps = {
  status: string;
};

export const ModelTagStatus = ({ status }: ModelTagStatusProps) => {
  const [statusTag, setStatusTag] = useState('');
  const [colorTag, setColorTag] = useState('');

  useEffect(() => {
    switch (status) {
      case 'VALIDATED':
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setStatusTag('Validated');
        setColorTag('emerald');
        break;
      case 'PROPOSAL_VALIDATED':
        setStatusTag('Proposal validated');
        setColorTag('amethyst');
        break;
      case 'CREATED':
        setStatusTag('Created');
        setColorTag('gold');
        break;
      default:
        setStatusTag('');
        setColorTag('');
    }
  }, [status]);

  const getColorTag = (colorTag: string) => {
    if (colorTag === 'emerald') {
      return 'decorative_emerald';
    } else if (colorTag === 'gold') {
      return 'decorative_gold';
    } else {
      return 'decorative_amethyst';
    }
  };

  return (
    statusTag && <VtmnTag variant={getColorTag(colorTag)}>{statusTag}</VtmnTag>
  );
};
